
const isAuth = state => state.isAuth;
const authUser = state => state.authUser;
const authRegistercompanies = state => state.authRegistercompanies

export default {
  authUser,
  isAuth,
  authRegistercompanies
};